var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var initialAuthState = {
    isAuthenticated: false,
    isLoading: true
};
export var authReducer = function (state, action) {
    switch (action.type) {
        case 'INITIALISED':
            return __assign(__assign({}, state), { isAuthenticated: !!action.user, user: action.user, isLoading: false, error: undefined });
        case 'USER_UPDATED':
            return __assign(__assign({}, state), { isAuthenticated: !!action.user, user: action.user });
        case 'ERROR':
            return __assign(__assign({}, state), { isLoading: false, error: action.error });
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map